import { render, staticRenderFns } from "./JettyCard.vue?vue&type=template&id=1c27cefb&scoped=true&"
import script from "./JettyCard.vue?vue&type=script&lang=js&"
export * from "./JettyCard.vue?vue&type=script&lang=js&"
import style0 from "./JettyCard.vue?vue&type=style&index=0&id=1c27cefb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c27cefb",
  null
  
)

export default component.exports